import * as React from 'react'
import {
  Box,
  Checkbox,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { NodeType, QuestionType } from 'shared/types/ingestion'
import ListItemText from '@mui/material/ListItemText'

function TypeSelector({
  selectedTypes,
  availableTypes,
  title,
  typeAttrs = {},
  selectionChanged,
}: {
  selectedTypes: string[]
  availableTypes: string[]
  title: string
  typeAttrs?: { [key: string]: unknown }
  selectionChanged: (selected: string[]) => void
}) {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event
    selectionChanged(typeof value === 'string' ? value.split(',') : value)
  }

  return (
    <FormControl>
      <Box>{title}</Box>
      <Select
        labelId="typeSelect-label"
        multiple
        value={selectedTypes}
        input={<OutlinedInput />}
        renderValue={(sel) =>
          sel.length === 1 ? sel[0] : `${sel.length} selected`
        }
        onChange={handleChange}
      >
        {availableTypes.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={selectedTypes.includes(name)} />
            <ListItemText primary={`${name} ${typeAttrs[name] ?? ''}`} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export function NodeTypeSelector({
  selectedTypes,
  typeAttrs = {},
  extraTypes = [],
  selectionChanged,
}: {
  selectedTypes: string[]
  typeAttrs?: { [key: string]: unknown }
  extraTypes?: string[]
  selectionChanged: (selected: string[]) => void
}) {
  return (
    <TypeSelector
      title={'What Types Of Nodes?'}
      selectedTypes={selectedTypes}
      availableTypes={[...Object.values(NodeType), ...extraTypes]}
      typeAttrs={typeAttrs}
      selectionChanged={selectionChanged}
    />
  )
}

export function QuestionTypeSelector({
  selectedTypes,
  typeAttrs,
  selectionChanged,
}: {
  selectedTypes: string[]
  typeAttrs: { [key: string]: unknown }
  selectionChanged: (selected: string[]) => void
}) {
  return (
    <TypeSelector
      selectedTypes={selectedTypes}
      availableTypes={Object.values(QuestionType)}
      title={'What Type Of Questions?'}
      typeAttrs={typeAttrs}
      selectionChanged={selectionChanged}
    />
  )
}
